import { ReactComponent as IconClose } from '../../public/images/svg/icon_close.svg';
import { SIMILARITY } from './enum';

const SimilarityCheckerModal = ({ isOpen, onClick, items }) => {
  if (items.length <= 0 || !isOpen) {
    return null;
  }

  return (
    <div
      className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
      onClick={onClick}
      data-testid="generated-prompt-similarity-checker-modal-wrapper"
    >
      <div
        className="relative w-auto my-6 mx-auto max-w-3xl"
        onClick={(evt) => evt.stopPropagation()}
      >
        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex flex-col items-end justify-between mb-8">
            <button
              className="bg-transparent border-0  h-6 w-6 m-2 flex items-center justify-center"
              data-testid="generated-prompt-similarity-checker-modal-close"
              onClick={onClick}
            >
              <IconClose />
            </button>
            <h2 className="w-full font-semibold flex flex-row justify-center text-xl">
              Similarity Checker
            </h2>
          </div>
          {items.map((item, index, arr) => {
            const { bgColor, icon, contentTitle } = SIMILARITY[item.similarityScore];
            const key = `generated-prompt-similarity-checker-modal-${item.title.replace(' ', '-')}`;
            return (
              <div
                key={key}
                data-testid={key}
                className={`relative px-10 flex-auto ${index < arr.length ? 'mb-8' : ''}`}
              >
                <div
                  data-testid={`${key}-title`}
                  className={` w-full p-4 ${bgColor} flex gap-4 text-grey-400 font-medium mb-8`}
                >
                  {icon}
                  <span>{contentTitle(item.title)}</span>
                </div>
                <div
                  data-testid={`${key}-content`}
                  className={`whitespace-break-spaces ${
                    items.length > 1 ? 'max-h-56 overflow-y-auto' : 'max-h-[600px] overflow-y-auto'
                  }`}
                >
                  {item.similarityReport.trim()}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SimilarityCheckerModal;
